import React from 'react';
import { WelcomeContent } from 'components/welcome/WelcomeContent';

import { withoutLogin } from 'pages/hocs/withoutLogin';

export const WelcomePage: React.FC = withoutLogin(() => {
  return <WelcomeContent />;
});
